module.exports = __webpack_public_path__ + "static/img/IMG_20150307_182219.d79ee81e.jpg";